(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var animation_block = document.querySelectorAll('.animation_block');
    animation_block.forEach((block) => {
      var a_links = block.querySelectorAll('a');
      console.log('a_links', a_links);
      if (a_links.length > 3) {
      } else {
        switch (a_links.length) {
          case 1:
            break;
          case 2:
            var d_0 = a_links[0].querySelector('.desktop');
            a_links[0].style.animation = '4s linear 0s infinite normal none running ani_2_0';
            block.style.height = d_0.clientWidth + 'px';

            var d_1 = a_links[1].querySelector('.desktop');
            a_links[1].style.animation = '4s linear 0s infinite normal none running ani_2_1';
            break;
          case 3:
            var d_0 = a_links[0].querySelector('.desktop');
            a_links[0].style.animation = '6s linear 0s infinite normal none running ani_3_0';
            block.style.height = d_0.clientWidth + 'px';

            var d_1 = a_links[1].querySelector('.desktop');
            a_links[1].style.animation = '6s linear 0s infinite normal none running ani_3_1';

            var d_2 = a_links[2].querySelector('.desktop');
            a_links[2].style.animation = '6s linear 0s infinite normal none running ani_3_2';
            break;
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-value-prop-style"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-brand-value-prop]').forEach((root) => {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';

      const viewport = root.querySelector('[data-brand-value-viewport]');
      const indicator = root.querySelector('[data-brand-value-indicator]');
      const autoplay = root.dataset.autoplay === 'true';
      const autoplayDelay = Number(root.dataset.autoplayMs) || 5000;
      const pauseReasons = new Set();
      let timer;
      let activePointerId;
      let startX = 0;
      let startLeft = 0;
      let dragging = false;

      const isScrollable = () => viewport.scrollWidth > viewport.clientWidth + 1;
      const slideWidth = () => viewport.clientWidth;

      const update = () => {
        const max = viewport.scrollWidth - viewport.clientWidth;
        const progress = max ? viewport.scrollLeft / max : 0;
        if (indicator) indicator.style.transform = `scaleX(${Math.max(.25, progress)})`;
      };

      const next = () => {
        if (!isScrollable()) return;
        const width = slideWidth();
        const slideCount = Math.round(viewport.scrollWidth / width);
        const currentIndex = Math.round(viewport.scrollLeft / width);
        const nextIndex = (currentIndex + 1) % slideCount;
        viewport.scrollTo({ left: nextIndex * width, behavior: 'smooth' });
      };

      const scheduleAutoplay = () => {
        window.clearTimeout(timer);
        if (!autoplay || pauseReasons.size || !isScrollable()) return;
        timer = window.setTimeout(() => {
          next();
          scheduleAutoplay();
        }, autoplayDelay);
      };

      const setPaused = (reason, paused) => {
        if (paused) pauseReasons.add(reason);
        else pauseReasons.delete(reason);
        scheduleAutoplay();
      };

      const snapToNearest = () => {
        if (!isScrollable()) return;
        const width = slideWidth();
        const targetIndex = Math.round(viewport.scrollLeft / width);
        viewport.scrollTo({ left: targetIndex * width, behavior: 'smooth' });
      };

      viewport.addEventListener('scroll', update, { passive: true });
      viewport.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || !isScrollable()) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        dragging = true;
        activePointerId = event.pointerId;
        startX = event.clientX;
        startLeft = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
        setPaused('interaction', true);

        if (event.pointerType === 'mouse') event.preventDefault();
      });

      viewport.addEventListener('pointermove', (event) => {
        if (!dragging || event.pointerId !== activePointerId) return;
        viewport.scrollLeft = startLeft - (event.clientX - startX);
        if (event.pointerType === 'mouse' && event.cancelable) event.preventDefault();
      });

      const finishDrag = (event) => {
        if (!dragging || event.pointerId !== activePointerId) return;
        dragging = false;
        activePointerId = undefined;
        viewport.classList.remove('is-dragging');
        if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
        if (event.type !== 'pointercancel') snapToNearest();
        setPaused('interaction', false);
      };

      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);
      root.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') setPaused('hover', true);
      });
      root.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') setPaused('hover', false);
      });
      document.addEventListener('visibilitychange', () => setPaused('visibility', document.hidden));
      window.addEventListener('resize', update, { passive: true });

      update();
      scheduleAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-figma-products"]) return;
  try {
    
  (() => {
    const splitTitle = (title) => {
      const trimmed = (title || '').trim();
      if (!trimmed) return { primary: '', secondary: '' };

      if (trimmed.includes(',')) {
        const [primary, ...secondaryParts] = trimmed.split(',');
        return {
          primary: primary.trim(),
          secondary: secondaryParts.map((part) => part.trim()).filter(Boolean).join(', '),
        };
      }

      return { primary: trimmed, secondary: '' };
    };

    const updateTitle = (element, title) => {
      if (!element) return;
      const parts = splitTitle(title);
      element.replaceChildren();

      const primary = document.createElement('span');
      primary.className = 'collection-figma-product-card__title-primary';
      primary.textContent = parts.primary;
      element.appendChild(primary);

      if (parts.secondary) {
        const secondary = document.createElement('span');
        secondary.className = 'collection-figma-product-card__title-secondary';
        secondary.textContent = parts.secondary;
        element.appendChild(secondary);
      }
    };

    const initCard = (card) => {
      if (!card || card.dataset.collectionCardReady === 'true') return;
      card.dataset.collectionCardReady = 'true';

      const links = card.querySelectorAll('[data-collection-card-link], [data-collection-card-media-link]');
      const image = card.querySelector(
        '.collection-figma-product-card__image:not(.collection-figma-product-card__image--hover)'
      );
      const hoverImage = card.querySelector('.collection-figma-product-card__image--hover');
      const title = card.querySelector('[data-collection-card-title]');
      const subtitle = card.querySelector('[data-collection-card-subtitle]');
      const price = card.querySelector('[data-collection-card-price]');
      const swatchList = card.querySelector('.collection-figma-product-card__swatches');
      const swatches = [...card.querySelectorAll('[data-collection-card-swatch]')];

      if (!swatches.length) return;

      const updateSwatchOverflow = () => {
        if (!swatchList) return;

        const overflow = swatchList.scrollWidth > swatchList.clientWidth + 1;
        const atStart = swatchList.scrollLeft <= 1;
        const atEnd = swatchList.scrollLeft + swatchList.clientWidth >= swatchList.scrollWidth - 1;
        swatchList.classList.toggle('is-overflowing', overflow);
        swatchList.classList.toggle('is-at-start', atStart);
        swatchList.classList.toggle('is-at-end', atEnd);
      };

      const setActive = (swatch, scrollIntoView = false) => {
        swatches.forEach((item) => {
          const active = item === swatch;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        updateTitle(title, swatch.dataset.title);
        if (subtitle) subtitle.textContent = swatch.dataset.subtitle || '';
        if (price) price.textContent = swatch.dataset.price || '';

        if (swatch.dataset.url) {
          links.forEach((link) => {
            link.href = swatch.dataset.url;
            link.setAttribute('aria-label', swatch.dataset.title || 'Product');
          });
        }

        if (image && swatch.dataset.image) {
          image.src = swatch.dataset.image;
          image.srcset = '';
          image.alt = swatch.dataset.alt || swatch.dataset.title || '';
        }

        if (hoverImage) {
          hoverImage.hidden = !swatch.dataset.hoverImage;
          if (swatch.dataset.hoverImage) {
            hoverImage.src = swatch.dataset.hoverImage;
            hoverImage.srcset = '';
            hoverImage.alt = swatch.dataset.hoverAlt || swatch.dataset.title || '';
          }
        }

        if (scrollIntoView && swatchList && window.matchMedia('(max-width: 749px)').matches) {
          const targetLeft = swatch.offsetLeft - (swatchList.clientWidth - swatch.offsetWidth) / 2;
          swatchList.scrollTo({ left: targetLeft, behavior: 'smooth' });
        }
      };

      if (swatchList) {
        swatchList.addEventListener('scroll', updateSwatchOverflow, { passive: true });
        window.addEventListener('resize', updateSwatchOverflow, { passive: true });
        requestAnimationFrame(updateSwatchOverflow);
      }

      swatches.forEach((swatch) => {
        swatch.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          setActive(swatch, true);
          swatch.blur();
        });
      });

      setActive(swatches.find((swatch) => swatch.classList.contains('is-active')) || swatches[0]);
    };

    const initAll = (root = document) => {
      if (root.matches?.('[data-collection-figma-card]')) initCard(root);
      root.querySelectorAll?.('[data-collection-figma-card]').forEach(initCard);
    };

    initAll();

    if (!window.__collectionFigmaProductsBound) {
      new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) initAll(node);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
      window.__collectionFigmaProductsBound = true;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tab"] && !Shopify.designMode) return;
  try {
    
  // document.addEventListener('DOMContentLoaded', function () {
  //   var prodquery = document.querySelectorAll('.bls__product-name .customerizeTitle');
  //   prodquery.forEach((prodEl) => {
  //     var title = prodEl.attributes['data-title'].value;
  //     var newT = showCustomerizeName(title);
  //     prodEl.innerText = '';
  //     prodEl.insertAdjacentHTML('afterbegin', newT);
  //   });
  //   var sizequery = document.querySelectorAll('.bls__product-name .customerizeSize');
  //   sizequery.forEach((prodEl) => {
  //     var title = prodEl.attributes['data-title'].value;
  //     fetch('/products/' + title + '.js')
  //       .then((response) => response.json())
  //       .then((product) => {
  //         var cap = '',
  //           weight = '';
  //         var desc = product.description;
  //         var index = productList.findIndex((prod) => product.title.startsWith(prod.title));
  //         var sizeFlag = product.title.split(productList[index].title);
  //         var size = '';
  //         if (sizeFlag.length > 1) size = sizeFlag[1];
  //         if (size[0] == ' ') size = size.replace(' ', '');
  //         var CAPACITY_last = desc.split('CAPACITY')[1];
  //         var CAPACITY_WEIGHT = CAPACITY_last.split('WEIGHT')[0];
  //         var WEIGHT_last = desc.split('WEIGHT')[1].split('<h3>')[0];
  //         // 若链接标题包含尺寸，则根据尺寸定点数据
  //         if (size != '') {
  //           // 判断CAPACITY描述中是否包含尺寸信息
  //           if (CAPACITY_WEIGHT.split(size).length > 1) {
  //             cap = CAPACITY_WEIGHT.split(size)[1].split('</div>')[0];
  //           } else {
  //             cap = CAPACITY_WEIGHT.split('">')[1].split('</div>')[0];
  //           }
  //           // 判断WEIGHT描述中是否包含尺寸信息
  //           if (WEIGHT_last.split(size).length > 1) {
  //             weight = WEIGHT_last.split(size)[1].split('</div>')[0];
  //           } else {
  //             weight = WEIGHT_last.split('">')[1].split('</div>')[0];
  //           }
  //         } else {
  //           // 判断CAPACITY描述中是否包含多尺寸信息
  //           if (CAPACITY_WEIGHT.split('<div>').length == 1) {
  //             cap = CAPACITY_WEIGHT.split('">')[1].split('</div>')[0];
  //           }
  //           // 判断WEIGHT描述中是否包含多尺寸信息
  //           if (WEIGHT_last.split('<div>').length == 1) {
  //             weight = WEIGHT_last.split('">')[1].split('</div>')[0];
  //           }
  //         }
  //         if (cap != '' && weight != '') {
  //           prodEl.insertAdjacentHTML(
  //             'afterbegin',
  //             '<span style="font-size: 16px;color: rgba(166, 166, 166, 1);">' +
  //               cap.replace(':', '').replace('：', '').replace(size, '') +
  //               '&nbsp;' +
  //               weight.replace(':', '').replace('：', '').replace(size, '') +
  //               '</span>'
  //           );
  //         }
  //       });
  //   });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const splitTitle = (title) => {
      const trimmed = (title || '').trim();
      if (!trimmed) return { primary: 'PRODUCT NAME', secondary: '' };

      const words = trimmed.split(/\s+/);
      if (words.length === 1) return { primary: trimmed, secondary: '' };

      return {
        primary: words.slice(0, -1).join(' '),
        secondary: words[words.length - 1],
      };
    };

    const updateTitle = (element, title) => {
      if (!element) return;

      const parts = splitTitle(title);
      element.replaceChildren();

      const primary = document.createElement('span');
      primary.className = 'featured-products__title-primary';
      primary.textContent = parts.primary;
      element.appendChild(primary);

      if (parts.secondary) {
        const secondary = document.createElement('span');
        secondary.className = 'featured-products__title-secondary';
        secondary.textContent = parts.secondary;
        element.appendChild(secondary);
      }
    };

    const initCard = (card) => {
      if (!card || card.dataset.featuredCardReady === 'true') return;
      card.dataset.featuredCardReady = 'true';

      const links = Array.from(card.querySelectorAll('[data-featured-card-link]'));
      const image = card.querySelector('.featured-products__image:not(.featured-products__image--hover)');
      const hoverImage = card.querySelector('.featured-products__image--hover');
      const title = card.querySelector('[data-featured-card-title]');
      const subtitle = card.querySelector('[data-featured-card-subtitle]');
      const price = card.querySelector('[data-featured-card-price]');
      const swatches = Array.from(card.querySelectorAll('[data-featured-swatch]'));

      if (!swatches.length) return;

      const setActive = (swatch) => {
        swatches.forEach((item) => {
          const isActive = item === swatch;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        updateTitle(title, swatch.dataset.title);

        if (subtitle) {
          subtitle.textContent = swatch.dataset.subtitle || '';
        }

        if (price) {
          price.textContent = swatch.dataset.price || '';
        }

        if (swatch.dataset.url) {
          links.forEach((link) => {
            link.href = swatch.dataset.url;
            link.setAttribute('aria-label', swatch.dataset.title || 'Product');
          });
        }

        if (image && swatch.dataset.image) {
          image.srcset = '';
          image.src = swatch.dataset.image;
          image.alt = swatch.dataset.alt || swatch.dataset.title || '';
        }

        if (hoverImage) {
          if (swatch.dataset.hoverImage) {
            hoverImage.srcset = '';
            hoverImage.src = swatch.dataset.hoverImage;
            hoverImage.alt = swatch.dataset.hoverAlt || swatch.dataset.title || '';
            hoverImage.hidden = false;
          } else {
            hoverImage.hidden = true;
          }
        }
      };

      swatches.forEach((swatch) => {
        swatch.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          setActive(swatch);
          swatch.blur();
        });
      });

      const initiallyActive = swatches.find((swatch) => swatch.classList.contains('is-active')) || swatches[0];
      if (initiallyActive) {
        setActive(initiallyActive);
      }
    };

    const initSlider = (slider) => {
      if (!slider || slider.dataset.featuredSliderReady === 'true') return;
      if (slider.closest('[data-featured-cart-empty][hidden]')) return;
      slider.dataset.featuredSliderReady = 'true';

      const cards = Array.from(slider.querySelectorAll('[data-featured-product-card]'));
      const track = slider.querySelector('.featured-products__track');
      const scrollbar = slider.querySelector('[data-featured-scrollbar]');
      const scrollbarThumb = slider.querySelector('[data-featured-scrollbar-thumb]');
      cards.forEach(initCard);

      if (!track || !cards.length) return;

      let currentIndex = 0;
      let snapOffsets = [0];
      let autoScrollTimer = null;
      let scrollbarDrag = null;
      let swipeActive = false;
      let swipingHorizontally = false;
      let swipeStartX = 0;
      let swipeStartY = 0;
      let swipeDeltaX = 0;
      let blockClickUntil = 0;
      const pausedReasons = new Set();
      const mobileSwipeMedia = window.matchMedia('(max-width: 749px)');
      const autoScrollEnabled =
        slider.dataset.autoScroll === 'true' &&
        cards.length > 1 &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoScrollSpeed = Math.max(Number(slider.dataset.autoScrollSpeed) || 4000, 1000);

      const getCardWidth = () => cards[0]?.getBoundingClientRect().width || 0;

      const syncSnapOffsets = () => {
        const maxOffset = Math.max(0, track.scrollWidth - slider.clientWidth);
        const nextOffsets = [];

        cards.forEach((card) => {
          const offset = Math.min(card.offsetLeft, maxOffset);
          const previousOffset = nextOffsets[nextOffsets.length - 1];

          if (previousOffset === undefined || Math.abs(previousOffset - offset) > 1) {
            nextOffsets.push(offset);
          }
        });

        if (!nextOffsets.length) nextOffsets.push(0);
        if (Math.abs(nextOffsets[nextOffsets.length - 1] - maxOffset) > 1) {
          nextOffsets.push(maxOffset);
        }

        snapOffsets = nextOffsets;
        currentIndex = Math.min(currentIndex, snapOffsets.length - 1);
      };

      const getMetrics = () => {
        const viewportWidth = slider.clientWidth;
        const cardWidth = getCardWidth();
        const isHomepageMobile =
          mobileSwipeMedia.matches &&
          (document.body.classList.contains('template-index') ||
            document.body.classList.contains('ito-v2-layout--index'));
        const thumbWidth = isHomepageMobile
          ? Math.min(viewportWidth, 88)
          : window.matchMedia('(min-width: 1100px)').matches
            ? Math.min(viewportWidth, (viewportWidth * 347) / 1820)
            : Math.min(viewportWidth, cardWidth);
        const maxOffset = snapOffsets[snapOffsets.length - 1] || 0;

        return {
          cardWidth,
          maxIndex: Math.max(0, snapOffsets.length - 1),
          maxOffset,
          thumbTravel: Math.max(0, viewportWidth - thumbWidth),
          thumbWidth,
        };
      };

      const moveTrackTo = (offset) => {
        track.style.transform = `translate3d(-${offset}px, 0, 0)`;
      };

      const updateScrollbar = () => {
        if (!scrollbarThumb) return;

        const metrics = getMetrics();
        const offset = snapOffsets[currentIndex] || 0;
        const progress = metrics.maxOffset > 0 ? offset / metrics.maxOffset : 0;

        scrollbarThumb.style.width = `${metrics.thumbWidth}px`;
        scrollbarThumb.style.transform = `translateX(${metrics.thumbTravel * progress}px)`;
        scrollbarThumb.setAttribute('aria-valuemax', String(metrics.maxIndex));
        scrollbarThumb.setAttribute('aria-valuenow', String(currentIndex));
      };

      const render = () => {
        syncSnapOffsets();
        moveTrackTo(snapOffsets[currentIndex] || 0);
        updateScrollbar();
      };

      const moveFromProgress = (progress) => {
        const metrics = getMetrics();
        const limitedProgress = Math.max(0, Math.min(progress, 1));

        moveTrackTo(metrics.maxOffset * limitedProgress);
        if (scrollbarThumb) {
          scrollbarThumb.style.transform = `translateX(${metrics.thumbTravel * limitedProgress}px)`;
        }

        return limitedProgress;
      };

      const setPaused = (reason, isPaused) => {
        if (isPaused) {
          pausedReasons.add(reason);
        } else {
          pausedReasons.delete(reason);
        }

        scheduleAutoScroll();
      };

      const scheduleAutoScroll = () => {
        window.clearTimeout(autoScrollTimer);

        if (
          !autoScrollEnabled ||
          pausedReasons.size > 0 ||
          document.hidden ||
          slider.closest('[data-featured-cart-empty][hidden]') ||
          snapOffsets.length <= 1
        ) {
          return;
        }

        autoScrollTimer = window.setTimeout(() => {
          currentIndex = currentIndex >= snapOffsets.length - 1 ? 0 : currentIndex + 1;
          render();
          scheduleAutoScroll();
        }, autoScrollSpeed);
      };

      scrollbarThumb?.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 && event.pointerType === 'mouse') return;

        const metrics = getMetrics();
        if (!metrics.maxOffset || !metrics.thumbTravel) return;

        event.preventDefault();
        event.stopPropagation();
        setPaused('scrollbar', true);
        scrollbarDrag = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startProgress: (snapOffsets[currentIndex] || 0) / metrics.maxOffset,
          progress: (snapOffsets[currentIndex] || 0) / metrics.maxOffset,
        };
        slider.classList.add('is-scrollbar-dragging');
        scrollbarThumb.setPointerCapture(event.pointerId);
      });

      scrollbarThumb?.addEventListener('pointermove', (event) => {
        if (!scrollbarDrag || event.pointerId !== scrollbarDrag.pointerId) return;

        event.preventDefault();
        const metrics = getMetrics();
        const startThumbX = metrics.thumbTravel * scrollbarDrag.startProgress;
        const nextThumbX = Math.max(
          0,
          Math.min(startThumbX + event.clientX - scrollbarDrag.startX, metrics.thumbTravel)
        );
        const progress = metrics.thumbTravel > 0 ? nextThumbX / metrics.thumbTravel : 0;
        scrollbarDrag.progress = moveFromProgress(progress);
      });

      const finishScrollbarDrag = (event) => {
        if (!scrollbarDrag || event.pointerId !== scrollbarDrag.pointerId) return;

        const targetOffset = scrollbarDrag.progress * getMetrics().maxOffset;
        currentIndex = snapOffsets.reduce(
          (closestIndex, offset, index) =>
            Math.abs(offset - targetOffset) < Math.abs(snapOffsets[closestIndex] - targetOffset)
              ? index
              : closestIndex,
          0
        );
        scrollbarDrag = null;
        slider.classList.remove('is-scrollbar-dragging');

        if (scrollbarThumb.hasPointerCapture(event.pointerId)) {
          scrollbarThumb.releasePointerCapture(event.pointerId);
        }

        render();
        setPaused('scrollbar', false);
      };

      scrollbarThumb?.addEventListener('pointerup', finishScrollbarDrag);
      scrollbarThumb?.addEventListener('pointercancel', finishScrollbarDrag);

      scrollbar?.addEventListener('click', (event) => {
        if (event.target === scrollbarThumb || scrollbarDrag) return;

        const metrics = getMetrics();
        if (!metrics.maxOffset || !metrics.thumbTravel) return;

        event.preventDefault();
        event.stopPropagation();
        const bounds = scrollbar.getBoundingClientRect();
        const targetX = event.clientX - bounds.left - metrics.thumbWidth / 2;
        const progress = Math.max(0, Math.min(targetX / metrics.thumbTravel, 1));
        const targetOffset = progress * metrics.maxOffset;
        currentIndex = snapOffsets.reduce(
          (closestIndex, offset, index) =>
            Math.abs(offset - targetOffset) < Math.abs(snapOffsets[closestIndex] - targetOffset)
              ? index
              : closestIndex,
          0
        );
        render();
        scheduleAutoScroll();
      });

      scrollbarThumb?.addEventListener('keydown', (event) => {
        let nextIndex = currentIndex;

        if (event.key === 'ArrowLeft') nextIndex -= 1;
        else if (event.key === 'ArrowRight') nextIndex += 1;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = snapOffsets.length - 1;
        else return;

        event.preventDefault();
        currentIndex = Math.max(0, Math.min(nextIndex, snapOffsets.length - 1));
        render();
        scheduleAutoScroll();
      });

      slider.addEventListener(
        'touchstart',
        (event) => {
          if (
            !mobileSwipeMedia.matches ||
            event.touches.length !== 1 ||
            event.target.closest('[data-featured-scrollbar]')
          ) {
            return;
          }

          swipeActive = true;
          swipingHorizontally = false;
          swipeDeltaX = 0;
          swipeStartX = event.touches[0].clientX;
          swipeStartY = event.touches[0].clientY;
          setPaused('swipe', true);
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchmove',
        (event) => {
          if (!mobileSwipeMedia.matches || !swipeActive || event.touches.length !== 1) return;

          swipeDeltaX = event.touches[0].clientX - swipeStartX;
          const deltaY = event.touches[0].clientY - swipeStartY;
          const distanceX = Math.abs(swipeDeltaX);
          const distanceY = Math.abs(deltaY);

          if (!swipingHorizontally) {
            if (distanceX < 8 && distanceY < 8) return;

            if (distanceY >= distanceX) {
              swipeActive = false;
              setPaused('swipe', false);
              return;
            }

            swipingHorizontally = true;
          }

          event.preventDefault();
          const metrics = getMetrics();
          const startOffset = snapOffsets[currentIndex] || 0;
          const nextOffset = Math.max(0, Math.min(startOffset - swipeDeltaX, metrics.maxOffset));
          moveTrackTo(nextOffset);

          if (scrollbarThumb) {
            const progress = metrics.maxOffset > 0 ? nextOffset / metrics.maxOffset : 0;
            scrollbarThumb.style.transform = `translateX(${metrics.thumbTravel * progress}px)`;
          }
        },
        { passive: false }
      );

      const finishMobileSwipe = () => {
        if (!swipeActive) return;

        const cardWidth = getCardWidth();
        const swipeDistance = Math.abs(swipeDeltaX);

        if (swipingHorizontally && cardWidth && swipeDistance >= Math.max(36, cardWidth * 0.15)) {
          const movedCards = Math.max(1, Math.round(swipeDistance / cardWidth));
          currentIndex += swipeDeltaX < 0 ? movedCards : -movedCards;
        }

        currentIndex = Math.max(0, Math.min(currentIndex, snapOffsets.length - 1));
        if (swipeDistance > 8) blockClickUntil = Date.now() + 400;

        swipeActive = false;
        swipingHorizontally = false;
        swipeDeltaX = 0;
        render();
        setPaused('swipe', false);
      };

      slider.addEventListener('touchend', finishMobileSwipe, { passive: true });
      slider.addEventListener(
        'touchcancel',
        () => {
          swipeActive = false;
          swipingHorizontally = false;
          swipeDeltaX = 0;
          render();
          setPaused('swipe', false);
        },
        { passive: true }
      );
      slider.addEventListener(
        'click',
        (event) => {
          if (Date.now() >= blockClickUntil) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      slider.addEventListener('pointerenter', () => setPaused('hover', true));
      slider.addEventListener('pointerleave', () => setPaused('hover', false));
      slider.addEventListener('focusin', () => setPaused('focus', true));
      slider.addEventListener('focusout', (event) => {
        if (!slider.contains(event.relatedTarget)) {
          setPaused('focus', false);
        }
      });
      document.addEventListener('visibilitychange', scheduleAutoScroll);
      slider.addEventListener('featured-products:visibility-change', () => {
        if (!slider.closest('[data-featured-cart-empty][hidden]')) render();
        scheduleAutoScroll();
      });
      window.addEventListener('resize', () => {
        render();
        scheduleAutoScroll();
      });
      render();
      scheduleAutoScroll();
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-featured-products-slider]').forEach(initSlider);
      root.querySelectorAll('[data-featured-size-guide-modal]').forEach((modal) => {
        if (modal.dataset.featuredSizeGuideReady === 'true') return;
        modal.dataset.featuredSizeGuideReady = 'true';

        modal.querySelector('[data-featured-size-guide-close]')?.addEventListener('click', () => {
          modal.close();
        });

        modal.addEventListener('click', (event) => {
          if (event.target === modal) {
            modal.close();
          }
        });

        modal.addEventListener('close', () => {
          document.body.classList.remove('featured-size-guide-open');
        });

        const trigger = document.querySelector('.product-detail__size-guide');
        if (trigger && trigger.dataset.featuredSizeGuideModal !== modal.id) {
          trigger.dataset.featuredSizeGuideModal = modal.id;
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', modal.id);
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            if (modal.open) return;

            syncSizeGuideColor(modal);
            modal.showModal();
            document.body.classList.add('featured-size-guide-open');
          });
        }
      });
    };

    const loadRelatedProducts = (section) => {
      if (!section || section.dataset.relatedProductsReady === 'true') return;

      const url = section.dataset.relatedProductsUrl;
      const carousel = section.querySelector('.featured-products__carousel');
      if (!url || !carousel) return;

      section.dataset.relatedProductsReady = 'true';

      const load = () => {
        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(`Unable to load related products: ${response.status}`);
            return response.text();
          })
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const renderedSection = html.querySelector('[data-featured-products-section]');
            const renderedCarousel = renderedSection?.querySelector('.featured-products__carousel');
            if (!renderedCarousel) return;

            carousel.replaceWith(renderedCarousel);
            initAll(section);
          })
          .catch((error) => {
            console.error(error);
          });
      };

      if (!('IntersectionObserver' in window)) {
        load();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0]?.isIntersecting) return;
          observer.disconnect();
          load();
        },
        { rootMargin: '0px 0px 1200px 0px' }
      );
      observer.observe(section);
    };

    const syncSizeGuideColor = (modal) => {
      const selectedColor = document.querySelector('[data-product-colour]')?.textContent.trim().toLowerCase();
      if (!selectedColor) return;

      modal.querySelectorAll('.featured-size-guide__product').forEach((productColumn) => {
        const variants = Array.from(productColumn.querySelectorAll('[data-featured-size-guide-variant]'));
        const matchingVariants = variants.filter((variant) => variant.dataset.color === selectedColor);
        const selectedVariant =
          matchingVariants.find((variant) => variant.dataset.available === 'true') || matchingVariants[0];

        if (!selectedVariant) return;

        const link = productColumn.querySelector('.featured-size-guide__product-link');
        const price = productColumn.querySelector('.featured-size-guide__summary p');
        const image = productColumn.querySelector('.featured-size-guide__image');

        if (link && selectedVariant.dataset.url) {
          link.href = selectedVariant.dataset.url;
        }

        if (price) {
          price.textContent = selectedVariant.dataset.price || '';
        }

        if (image && selectedVariant.dataset.image) {
          image.srcset = '';
          image.src = selectedVariant.dataset.image;
          image.alt = selectedVariant.dataset.alt || '';
        }
      });
    };

    const syncCartVisibility = (root = document, itemCount) => {
      const cartPage = document.querySelector('[data-ito-cart-page]');
      const isEmpty = Number.isInteger(itemCount)
        ? itemCount === 0
        : Boolean(cartPage?.querySelector('.ito-cart-v2--empty'));

      root.querySelectorAll('[data-featured-cart-empty]').forEach((section) => {
        // Keep the server-rendered state when there is no cart page to inspect.
        if (Number.isInteger(itemCount) || cartPage) section.hidden = !isEmpty;
        if (!section.hidden) initAll(section);
        section.querySelectorAll('[data-featured-products-slider]').forEach((slider) => {
          slider.dispatchEvent(new Event('featured-products:visibility-change'));
        });
      });
    };

    syncCartVisibility();
    initAll();
    document.querySelectorAll('[data-related-products-url]').forEach(loadRelatedProducts);

    if (!window.__featuredProductsBound) {
      document.addEventListener('ito:cart-updated', (event) => {
        syncCartVisibility(document, event.detail?.cart?.item_count);
      });
      document.addEventListener('shopify:section:load', (event) => {
        syncCartVisibility(event.target);
        initAll(event.target);
        event.target.querySelectorAll('[data-related-products-url]').forEach(loadRelatedProducts);
      });
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('.product-detail__size-guide');
        if (!trigger) return;

        const modal = document.querySelector('[data-featured-size-guide-modal]');
        if (!modal) return;

        event.preventDefault();
        if (modal.open) return;

        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', modal.id);
        syncSizeGuideColor(modal);
        modal.showModal();
        document.body.classList.add('featured-size-guide-open');
      });
      window.__featuredProductsBound = true;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 900px)');

    document
      .querySelectorAll('.site-header')
      .forEach((header) => {
        if (header.dataset.searchBound === 'true') return;

        const trigger = header.querySelector('.site-header__search');
        const panel = header.querySelector('.site-header__search-panel');
        const closeButton = header.querySelector('.site-header__search-close');
        const input = header.querySelector('.site-header__search-field input[type="search"]');

        if (!trigger || !panel || !closeButton || !input) return;

        header.dataset.searchBound = 'true';

                // Shared predictive search for desktop and mobile.
        const predictions = header.querySelector(
          '[data-header-search-predictions]'
        );

        if (predictions) {
          const status = predictions.querySelector('[data-search-status]');
          const products = predictions.querySelector('[data-search-products]');
          const viewAll = predictions.querySelector('[data-search-view-all]');

          if (status && products && viewAll) {
            let timer;
            let controller;
            let version = 0;

            const resetPredictions = () => {
              window.clearTimeout(timer);
              controller?.abort();
              version += 1;

              predictions.hidden = true;
              predictions.removeAttribute('aria-busy');
              products.replaceChildren();
              status.textContent = '';
              viewAll.hidden = true;
              viewAll.removeAttribute('href');
            };

            const formatPrice = (product) => {
              const value = product.price_min ?? product.price;
              const currency = predictions.dataset.currency;

              if (
                value === undefined ||
                value === null ||
                value === '' ||
                !currency
              ) return '';

              // Predictive JSON prices use major currency units.
              const amount = Number(value);
              if (!Number.isFinite(amount)) return '';

              try {
                return new Intl.NumberFormat(
                  document.documentElement.lang || 'en',
                  {
                    style: 'currency',
                    currency,
                    currencyDisplay: 'code'
                  }
                ).format(amount);
              } catch {
                return `${currency} ${amount.toFixed(2)}`;
              }
            };

            const createProductLink = (product) => {
              if (!product.url || !product.title) return null;

              let productUrl;

              try {
                productUrl = new URL(product.url, window.location.origin);
              } catch {
                return null;
              }

              if (productUrl.origin !== window.location.origin) return null;

              const link = document.createElement('a');
              link.className = 'site-header__prediction-product';
              link.href = productUrl.href;

              const imageSlot = document.createElement('span');
              imageSlot.className = 'site-header__prediction-image';

              const source =
                product.featured_image?.url || product.image;

              if (source) {
                try {
                  const imageUrl = new URL(source, window.location.origin);

                  if (imageUrl.protocol === 'https:') {
                    const image = document.createElement('img');
                    image.src = imageUrl.href;
                    image.alt = '';
                    image.width = 80;
                    image.height = 80;
                    image.loading = 'lazy';
                    image.decoding = 'async';
                    imageSlot.appendChild(image);
                  }
                } catch {
                  // Keep the text link usable if an image is invalid.
                }
              }

              link.appendChild(imageSlot);

              const info = document.createElement('span');
              info.className = 'site-header__prediction-info';

              const title = document.createElement('span');
              title.className = 'site-header__prediction-title';
              title.textContent = product.title;
              info.appendChild(title);

              const formattedPrice = formatPrice(product);

              if (formattedPrice) {
                const price = document.createElement('span');
                price.className = 'site-header__prediction-price';
                price.textContent = formattedPrice;
                info.appendChild(price);
              }

              link.appendChild(info);
              return link;
            };

                       const fetchPredictions = async (term, requestVersion) => {
              const requestController = new AbortController();
              controller = requestController;

              try {
                const path = predictions.dataset.predictiveUrl;

                if (!path) {
                  throw new Error('Missing predictive URL');
                }

                const url = new URL(
                  path,
                  window.location.origin
                );

                url.pathname = url.pathname.replace(/\/$/, '');

                if (!url.pathname.endsWith('.json')) {
                  url.pathname += '.json';
                }

                url.searchParams.set('q', term);
                url.searchParams.set('resources[type]', 'product');
                url.searchParams.set('resources[limit]', '6');

                let response = await fetch(url.href, {
                  signal: requestController.signal,
                  headers: {
                    Accept: 'application/json'
                  }
                });

                // 417：当前买家语言不支持原生预测搜索。
                // 改用当前语言路径下的普通搜索备用模板。
                if (response.status === 417) {
                  if (
                    requestVersion !== version ||
                    input.value.trim() !== term
                  ) {
                    return;
                  }

                  const fallbackUrl = new URL(
                    predictions.dataset.searchUrl,
                    window.location.origin
                  );

                  fallbackUrl.searchParams.set('q', term);
                  fallbackUrl.searchParams.set('type', 'product');
                  fallbackUrl.searchParams.set(
                    'options[prefix]',
                    'last'
                  );
                  fallbackUrl.searchParams.set(
                    'view',
                    'header-suggestions'
                  );

                  const unavailable = header.querySelector(
                    '.site-header__search-form ' +
                    '[name="options[unavailable_products]"]'
                  );

                  if (unavailable?.value) {
                    fallbackUrl.searchParams.set(
                      'options[unavailable_products]',
                      unavailable.value
                    );
                  }

                  response = await fetch(fallbackUrl.href, {
                    signal: requestController.signal,
                    headers: {
                      Accept: 'text/html'
                    }
                  });
                }

                if (!response.ok) {
                  throw new Error(
                    `Search request failed: ${response.status}`
                  );
                }

                // 备用 Liquid 模板也返回 JSON 文本。
                const data = await response.json();
                const items = data?.resources?.results?.products;

                if (!Array.isArray(items)) {
                  throw new Error('Invalid search response');
                }

                if (
                  requestVersion !== version ||
                  input.value.trim() !== term
                ) {
                  return;
                }

                const fragment = document.createDocumentFragment();

                items.forEach((product) => {
                  const link = createProductLink(product);

                  if (link) {
                    fragment.appendChild(link);
                  }
                });

                products.replaceChildren(fragment);
                products.scrollTop = 0;

                status.textContent = products.childElementCount
                  ? 'Products'
                  : 'No matching products found.';
              } catch (error) {
                if (
                  error.name === 'AbortError' ||
                  requestVersion !== version
                ) {
                  return;
                }

                console.warn('Header search failed:', error);

                products.replaceChildren();
                status.textContent =
                  'Suggestions are unavailable. View all results below.';
              } finally {
                if (requestVersion === version) {
                  predictions.removeAttribute('aria-busy');
                }
              }
            };

            const updatePredictions = () => {
              resetPredictions();

              const term = input.value.trim();
              if (!term) return;

              const requestVersion = version;
              const resultsUrl = new URL(
                predictions.dataset.searchUrl,
                window.location.origin
              );

              resultsUrl.searchParams.set('q', term);
              resultsUrl.searchParams.set('type', 'product');
              resultsUrl.searchParams.set('options[prefix]', 'last');

              const unavailable = header.querySelector(
                '.site-header__search-form ' +
                '[name="options[unavailable_products]"]'
              );

              if (unavailable?.value) {
                resultsUrl.searchParams.set(
                  'options[unavailable_products]',
                  unavailable.value
                );
              }

              viewAll.href = resultsUrl.href;
              viewAll.textContent = 'View all results';
              viewAll.hidden = false;

              status.textContent = 'Searching…';
              predictions.hidden = false;
              predictions.setAttribute('aria-busy', 'true');

              timer = window.setTimeout(() => {
                fetchPredictions(term, requestVersion);
              }, 250);
            };

            input.addEventListener('input', (event) => {
              if (event.isComposing) {
                resetPredictions();
                return;
              }

              updatePredictions();
            });

            input.addEventListener('compositionend', updatePredictions);

            input.addEventListener('focus', () => {
              if (
                panel.getAttribute('aria-hidden') !== 'true' &&
                input.value.trim() &&
                predictions.hidden
              ) {
                updatePredictions();
              }
            });

            panel.addEventListener('keydown', (event) => {
              if (
                event.isComposing ||
                predictions.hidden ||
                !['ArrowDown', 'ArrowUp'].includes(event.key)
              ) return;

              const links = [...products.querySelectorAll('a[href]')];

              if (!viewAll.hidden && viewAll.hasAttribute('href')) {
                links.push(viewAll);
              }

              if (!links.length) return;

              const active = document.activeElement;

              if (active === input) {
                if (event.key !== 'ArrowDown') return;

                event.preventDefault();
                links[0].focus();
                return;
              }

              const index = links.indexOf(active);
              if (index === -1) return;

              event.preventDefault();

              if (event.key === 'ArrowUp') {
                if (index === 0) {
                  input.focus();
                } else {
                  links[index - 1].focus();
                }
              } else if (index < links.length - 1) {
                links[index + 1].focus();
              }
            });

            const observer = new MutationObserver(() => {
              if (panel.getAttribute('aria-hidden') === 'true') {
                resetPredictions();
              }
            });

            observer.observe(panel, {
              attributes: true,
              attributeFilter: ['aria-hidden']
            });
          }
        }


        const closeSearch = ({ restoreFocus = false } = {}) => {
          if (!header.classList.contains('is-search-open')) return;

          header.classList.remove('is-search-open');
          trigger.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');

          if (restoreFocus) trigger.focus();
        };

        const openSearch = () => {
          document
            .querySelectorAll('.site-header__mega-menu[open], .site-header__country-menu[open], .site-header__mobile-menu[open]')
            .forEach((menu) => { menu.open = false; });

          header.classList.add('is-search-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');

          window.requestAnimationFrame(() => input.focus());
        };

        trigger.addEventListener('click', (event) => {
          event.preventDefault();

          if (header.classList.contains('is-search-open')) {
            closeSearch({ restoreFocus: true });
          } else {
            openSearch();
          }
        });

        closeButton.addEventListener('click', () => closeSearch({ restoreFocus: true }));
        const mobileMenu = header.querySelector(
  '.site-header__mobile-menu'
);

if (mobileMenu) {
  const mobileSummary = mobileMenu.querySelector(':scope > summary');

  // 打开手机菜单前关闭独立搜索。
  mobileSummary?.addEventListener('click', () => {
    if (!mobileMenu.open) closeSearch();
  });

  // 同时覆盖键盘或其他代码打开菜单的情况。
  mobileMenu.addEventListener('toggle', () => {
    if (mobileMenu.open) closeSearch();
  });
}


        header
          .querySelectorAll('.site-header__mega-menu > summary')
          .forEach((summary) => summary.addEventListener('pointerenter', () => closeSearch()));

        header
          .querySelectorAll('.site-header__country-menu > summary')
          .forEach((summary) => summary.addEventListener('click', () => closeSearch()));

        document.addEventListener('pointerdown', (event) => {
          if (!header.classList.contains('is-search-open')) return;
          if (!header.contains(event.target)) closeSearch();
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && header.classList.contains('is-search-open')) {
            closeSearch({ restoreFocus: true });
          }
        });

        desktopQuery.addEventListener('change', (event) => {
          if (!event.matches) closeSearch();
        });
      });

    document
      .querySelectorAll('.site-header__mega-menu')
      .forEach((menu) => {
        if (menu.dataset.bound === 'true') return;

        menu.dataset.bound = 'true';

        const summary = menu.querySelector('summary');
        const panel = menu.querySelector('.site-header__mega-panel');

        if (!summary || !panel) return;

        let closeTimer = null;

        const cancelClose = () => {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        };

        const openMenu = () => {
          if (!desktopQuery.matches) return;

          cancelClose();

          document
            .querySelectorAll('.site-header__mega-menu[open]')
            .forEach((otherMenu) => {
              if (otherMenu !== menu) {
                otherMenu.open = false;
              }
            });

          menu.open = true;
        };

        const scheduleClose = () => {
          if (!desktopQuery.matches) return;

          cancelClose();

          closeTimer = window.setTimeout(() => {
            const pointerOnSummary = summary.matches(':hover');
            const pointerOnPanel = panel.matches(':hover');
            const focusInsideMenu = menu.contains(document.activeElement);

            if (
              !pointerOnSummary &&
              !pointerOnPanel &&
              !focusInsideMenu
            ) {
              menu.open = false;
            }
          }, 350);
        };

        summary.addEventListener('pointerenter', openMenu);
        summary.addEventListener('pointerleave', scheduleClose);

        panel.addEventListener('pointerenter', openMenu);
        panel.addEventListener('pointerleave', scheduleClose);

        menu.addEventListener('focusin', openMenu);

        menu.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!menu.contains(document.activeElement)) {
              scheduleClose();
            }
          }, 0);
        });
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded',function(){
    const e = document.getElementById('account-logout')
    null !== e && e.addEventListener('click', (e) => {
      sessionStorage.removeItem('ITOAccessToken')
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    setMaskHeight();
    // listenPersonalClick();
    listenAcceptClick();
    listenCloseClick();
    // getWorkshop()
  });
  window.addEventListener('resize', () => {
    setMaskHeight();
  });
  var product = {};

  // 设置定制遮罩层高度
  function setMaskHeight() {
    var maskquery = document.querySelector('.customerizePersonal.mask');
    if (maskquery) maskquery.style.minHeight = window.innerHeight + 'px';
  }
  // 监听产品详情定制按钮点击
  function listenPersonalClick() {
    var e = document.querySelector('.shopify-payment-button');
    e.addEventListener('click', () => {
      var maskquery = document.querySelector('.customerizePersonal.mask');
      if (maskquery.style.display == 'none') {
        maskquery.style.display = 'block';
      }
      setMaskHeight();
      getWorkshop();
    });
  }
  // 监听定制遮罩层关闭按钮
  function listenCloseClick() {
    var e = document.querySelector('.customerizePersonal.mask .close');
    e.addEventListener('click', () => {
      var maskquery = document.querySelector('.customerizePersonal.mask');
      if (maskquery.style.display == 'block') {
        maskquery.style.display = 'none';
      }
    });
  }
  // 监听定制遮罩层确认按钮
  function listenAcceptClick() {
    var e = document.querySelector('.customerizePersonal.mask .accept');
    e.addEventListener('click', () => {
      // 隐藏定制导航
      e = document.querySelector('.customerizePersonal.mask .view');
      e.style.display = 'none';
      e = document.querySelector('.customerizePersonal.mask .tour');
      e.style.display = 'none';
      // 显示定制主体
      e = document.querySelector('.customerizePersonal.mask .preview');
      e.style.display = 'unset';
      e = document.querySelector('.customerizePersonal.mask .form');
      e.style.display = 'unset';
    });
  }
  // 获取定制信息
  function getWorkshop() {
    // 获取69码
    // fetch(window.location.pathname+'.js')
    //   .then(response => response.json())
    //   .then(p =>{
    //     console.log(p)
    //   })

    // 查询定制信息
    // fetch('https://travel.itocases.com/v3/product/ito/workshop/skupart?sku='+'DACB22301O03GRN14B000').then(response => response.json())
    //   .then(p =>{
    //     console.log(p)
    //   })
    var r = new XMLHttpRequest();
    r.open('GET', 'https://travel.itocases.com/v3/product/ito/workshop/skupart?sku=' + 'DACB22301O03GRN14B000', true);
    r.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    r.onreadystatechange = function () {
      var response = decodeURIComponent(r.responseText);
      if (response.code == 0) {
        product = response.data;
      }
      console.log(response.data);
    };
    r.send();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function resizeHandler() {
      var main = document.getElementById('MainContent');
      const isMobile = window.innerWidth <= 1024;
      if (isMobile) {
        main.style.background = 'none';
      } else {
        main.style.background =
          'url(https://cdn.shopify.com/s/files/1/0652/0605/9205/files/login_background.jpg?v=1724397636)';
        main.style.backgroundSize = 'cover';
      }
    }

    resizeHandler();

    window.addEventListener('resize', resizeHandler);
    const form = document.getElementById('create_customer');
    form.addEventListener('submit', function (event) {
      event.preventDefault(); // 阻止默认表单提交

      const formData = new FormData(form);
      fetch('/account', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      })
        .then((res) => res.text())
        .then((html) => {
          // 判断是否成功登录（通过返回 HTML 判断）
          if (html.includes('/account/logout') || html.includes('customer__account')) {
            let customer = '';
            // html = html.slice(html.indexOf('data-customer-id="'));
            // customer = html.slice(0, html.indexOf('"'));
            const searchStr = 'data-customer-id="';
            const startPos = html.indexOf(searchStr);

            if (startPos != -1) {
                // 1. 先跳过标记字符串本身，截取剩下的部分
                let tempHtml = html.slice(startPos + searchStr.length); 
                // 此时 tempHtml 是：12345" data-name="Jack">...
                
                // 2. 截取到下一个双引号出现为止
                customer = tempHtml.slice(0, tempHtml.indexOf('"'));
                // 结果：12345
            }
            // 事件处理逻辑
            let first_name = document.getElementById('first-name').value;
            let last_name = document.getElementById('last-name').value;
            let email = document.getElementById('email').value;
            let password = document.getElementById('password').value;
            registerRequest(first_name, last_name, email, password, customer, '', 'register')
              .then(function (res) {
                window.location.reload();
              })
              .catch(function (err) {
                alert(err);
              });
          } else {
            form.submit();
          }
        })
        .catch((err) => {
          console.error('登录出错：', err);
          alert('Something is error');
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-figma-policy"]) return;
  try {
    
  (() => {
    const enhancePolicyPage = (section) => {
      if (!section || section.dataset.policyAccordion !== 'true' || section.dataset.policyReady === 'true') return;

      const content = section.querySelector('[data-policy-content]');
      if (!content) return;

      const nodes = Array.from(content.children);
      const headings = nodes.filter((node) => node.tagName === 'H2');
      if (!headings.length) return;

      const intro = document.createElement('div');
      intro.className = 'ito-page-policy__intro';

      const list = document.createElement('div');
      list.className = 'ito-page-policy__list';

      let currentAnswer = null;
      let sectionIndex = 0;

      nodes.forEach((node) => {
        if (node.tagName === 'H2') {
          sectionIndex += 1;

          const details = document.createElement('details');
          details.name = `policy-accordion-${section.id}`;
          if (sectionIndex === 1) details.open = true;

          const summary = document.createElement('summary');
          const label = document.createElement('span');
          label.textContent = node.textContent.trim();

          const icon = document.createElement('span');
          icon.className = 'ito-page-policy__icon';
          icon.setAttribute('aria-hidden', 'true');

          summary.append(label, icon);

          currentAnswer = document.createElement('div');
          currentAnswer.className = 'ito-page-policy__answer rte';
          details.append(summary, currentAnswer);
          list.append(details);
          return;
        }

        (currentAnswer || intro).append(node);
      });

      content.replaceChildren();
      if (intro.childElementCount) content.append(intro);
      content.append(list);
      content.classList.add('is-accordion-ready');
      section.dataset.policyReady = 'true';
    };

    document.querySelectorAll('[data-policy-page]').forEach(enhancePolicyPage);

    document.addEventListener('shopify:section:load', (event) => {
      enhancePolicyPage(event.target.querySelector('[data-policy-page]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      const viewport = root.querySelector('[data-pdp-features-viewport]');
      const cards = Array.from(root.querySelectorAll('.pdp-features__card'));
      const scrollbar = root.querySelector('[data-pdp-features-scrollbar]');
      const thumb = root.querySelector('[data-pdp-features-scrollbar-thumb]');
      if (!viewport || !cards.length || !scrollbar || !thumb) return;

      const autoplayEnabled = root.dataset.autoplay === 'true';
      const autoplayMs = Number(root.dataset.autoplayMs) || 5000;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const pausedReasons = new Set();
      let snapOffsets = [];
      let currentIndex = 0;
      let animationFrame = 0;
      let autoplayTimer = 0;
      let scrollEndTimer = 0;
      let scrollbarDrag = null;

      const getMaxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);

      const getMetrics = () => {
        const viewportWidth = viewport.clientWidth;
        const maxScroll = getMaxScroll();
        const thumbWidth = maxScroll > 0
          ? viewportWidth * (viewportWidth / viewport.scrollWidth)
          : viewportWidth;

        return {
          maxScroll,
          thumbWidth,
          thumbTravel: Math.max(0, viewportWidth - thumbWidth),
        };
      };

      const getClosestIndex = (offset = viewport.scrollLeft) =>
        snapOffsets.reduce(
          (closestIndex, snapOffset, index) =>
            Math.abs(snapOffset - offset) < Math.abs(snapOffsets[closestIndex] - offset)
              ? index
              : closestIndex,
          0
        );

      const buildSnapOffsets = () => {
        const maxScroll = getMaxScroll();
        const offsets = cards.map((card) => Math.max(0, Math.min(card.offsetLeft, maxScroll)));

        snapOffsets = offsets.filter(
          (offset, index) => index === 0 || Math.abs(offset - offsets[index - 1]) > 1
        );

        if (!snapOffsets.length) snapOffsets = [0];
        if (Math.abs(snapOffsets[snapOffsets.length - 1] - maxScroll) > 1) {
          snapOffsets.push(maxScroll);
        }
      };

      const syncControls = () => {
        const metrics = getMetrics();
        const progress = metrics.maxScroll > 0 ? viewport.scrollLeft / metrics.maxScroll : 0;
        currentIndex = getClosestIndex();

        thumb.style.width = `${metrics.thumbWidth}px`;
        thumb.style.transform = `translate3d(${metrics.thumbTravel * progress}px,0,0)`;
        thumb.setAttribute('aria-valuemax', String(Math.max(0, snapOffsets.length - 1)));
        thumb.setAttribute('aria-valuenow', String(currentIndex));
        thumb.setAttribute('aria-disabled', String(metrics.maxScroll <= 0));
        thumb.tabIndex = metrics.maxScroll > 0 ? 0 : -1;
        scrollbar.classList.toggle('is-disabled', metrics.maxScroll <= 0);
      };

      const requestSync = () => {
        if (animationFrame) return;
        animationFrame = window.requestAnimationFrame(() => {
          animationFrame = 0;
          syncControls();
        });
      };

      const scrollToIndex = (index, behavior = 'smooth') => {
        currentIndex = Math.max(0, Math.min(index, snapOffsets.length - 1));
        viewport.scrollTo({
          left: snapOffsets[currentIndex] || 0,
          behavior: reducedMotion.matches ? 'auto' : behavior,
        });
        syncControls();
      };

      const snapToNearest = (behavior = 'smooth') => {
        if (scrollbarDrag) return;
        scrollToIndex(getClosestIndex(), behavior);
      };

      const scheduleAutoplay = () => {
        window.clearTimeout(autoplayTimer);
        if (
          !autoplayEnabled ||
          reducedMotion.matches ||
          pausedReasons.size ||
          document.hidden ||
          snapOffsets.length <= 1
        ) {
          return;
        }

        autoplayTimer = window.setTimeout(() => {
          const nextIndex = currentIndex >= snapOffsets.length - 1 ? 0 : currentIndex + 1;
          scrollToIndex(nextIndex);
          scheduleAutoplay();
        }, autoplayMs);
      };

      const setPaused = (reason, paused) => {
        if (paused) pausedReasons.add(reason);
        else pausedReasons.delete(reason);
        scheduleAutoplay();
      };

      const refresh = () => {
        buildSnapOffsets();
        currentIndex = getClosestIndex();
        syncControls();
        scheduleAutoplay();
      };

      viewport.addEventListener(
        'scroll',
        () => {
          requestSync();
          if (scrollbarDrag) return;
          if ('onscrollend' in viewport) return;

          window.clearTimeout(scrollEndTimer);
          scrollEndTimer = window.setTimeout(() => {
            snapToNearest();
            scheduleAutoplay();
          }, 140);
        },
        { passive: true }
      );

      viewport.addEventListener('scrollend', () => {
        window.clearTimeout(scrollEndTimer);
        syncControls();
        scheduleAutoplay();
      });

      thumb.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 && event.pointerType === 'mouse') return;
        const metrics = getMetrics();
        if (!metrics.maxScroll || !metrics.thumbTravel) return;

        event.preventDefault();
        event.stopPropagation();
        window.clearTimeout(scrollEndTimer);
        setPaused('scrollbar', true);
        scrollbarDrag = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startScroll: viewport.scrollLeft,
          startIndex: getClosestIndex(),
        };
        root.classList.add('is-scrollbar-dragging');
        thumb.setPointerCapture(event.pointerId);
      });

      thumb.addEventListener('pointermove', (event) => {
        if (!scrollbarDrag || event.pointerId !== scrollbarDrag.pointerId) return;
        event.preventDefault();

        const metrics = getMetrics();
        const startProgress = scrollbarDrag.startScroll / metrics.maxScroll;
        const startThumbX = startProgress * metrics.thumbTravel;
        const thumbX = Math.max(
          0,
          Math.min(startThumbX + event.clientX - scrollbarDrag.startX, metrics.thumbTravel)
        );
        viewport.scrollLeft = (thumbX / metrics.thumbTravel) * metrics.maxScroll;
        syncControls();
      });

      const finishScrollbarDrag = (event) => {
        if (!scrollbarDrag || event.pointerId !== scrollbarDrag.pointerId) return;
        const completedDrag = scrollbarDrag;
        const dragDistance = viewport.scrollLeft - completedDrag.startScroll;
        scrollbarDrag = null;
        window.clearTimeout(scrollEndTimer);
        root.classList.remove('is-scrollbar-dragging');

        if (thumb.hasPointerCapture(event.pointerId)) {
          thumb.releasePointerCapture(event.pointerId);
        }

        let targetIndex = getClosestIndex();
        if (Math.abs(dragDistance) >= 12 && targetIndex === completedDrag.startIndex) {
          targetIndex = completedDrag.startIndex + (dragDistance > 0 ? 1 : -1);
        }
        scrollToIndex(targetIndex);
        setPaused('scrollbar', false);
      };

      thumb.addEventListener('pointerup', finishScrollbarDrag);
      thumb.addEventListener('pointercancel', finishScrollbarDrag);
      thumb.addEventListener('lostpointercapture', (event) => {
        if (scrollbarDrag && event.pointerId === scrollbarDrag.pointerId) {
          finishScrollbarDrag(event);
        }
      });

      scrollbar.addEventListener('click', (event) => {
        if (event.target === thumb || scrollbarDrag) return;
        const metrics = getMetrics();
        if (!metrics.maxScroll || !metrics.thumbTravel) return;

        event.preventDefault();
        const bounds = scrollbar.getBoundingClientRect();
        const targetThumbX = event.clientX - bounds.left - metrics.thumbWidth / 2;
        const progress = Math.max(0, Math.min(targetThumbX / metrics.thumbTravel, 1));
        scrollToIndex(getClosestIndex(progress * metrics.maxScroll));
        scheduleAutoplay();
      });

      thumb.addEventListener('keydown', (event) => {
        let nextIndex = currentIndex;
        if (event.key === 'ArrowLeft') nextIndex -= 1;
        else if (event.key === 'ArrowRight') nextIndex += 1;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = snapOffsets.length - 1;
        else return;

        event.preventDefault();
        scrollToIndex(nextIndex);
        scheduleAutoplay();
      });

      viewport.addEventListener('touchstart', () => setPaused('touch', true), { passive: true });
      viewport.addEventListener(
        'touchend',
        () => {
          setPaused('touch', false);
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchcancel',
        () => {
          setPaused('touch', false);
          snapToNearest();
        },
        { passive: true }
      );

      root.addEventListener('pointerenter', () => setPaused('hover', true));
      root.addEventListener('pointerleave', () => setPaused('hover', false));
      root.addEventListener('focusin', () => setPaused('focus', true));
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) setPaused('focus', false);
      });
      document.addEventListener('visibilitychange', scheduleAutoplay);
      reducedMotion.addEventListener('change', scheduleAutoplay);

      const resizeObserver = new ResizeObserver(refresh);
      resizeObserver.observe(viewport);
      cards.forEach((card) => resizeObserver.observe(card));
      refresh();
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-pdp-features]')) init(scope);
      scope.querySelectorAll?.('[data-pdp-features]').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-lifestyle-gallery"] && !Shopify.designMode) return;
  try {
     (() => { document.querySelectorAll('[data-pdp-lifestyle]').forEach((root) => { if (root.dataset.bound) return; root.dataset.bound = 'true'; root.addEventListener('pointerdown', () => root.classList.add('is-paused')); root.addEventListener('pointerup', () => root.classList.remove('is-paused')); root.addEventListener('pointercancel', () => root.classList.remove('is-paused')); }); })(); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-product-sticky-bar]').forEach((bar) => {
      if (bar.dataset.bound) return;
      bar.dataset.bound = 'true';

      const input = bar.querySelector('[data-product-sticky-variant-input]');
      const submit = bar.querySelector('[data-product-sticky-submit]');
      const subtitle = bar.querySelector('[data-product-sticky-subtitle]');
      const price = bar.querySelector('[data-product-sticky-price]');
      const activeSwatch = document.querySelector(
        '[data-product-detail] [data-product-variant].is-active'
      );
      const setBackgroundColours = (background, backgroundProperty, textProperty) => {
        if (!background) return;

        bar.style.setProperty(backgroundProperty, background);
        const hex = background.trim().replace(/^#/, '');
        const expandedHex = hex.length === 3
          ? hex.split('').map((digit) => digit + digit).join('')
          : hex;

        if (!/^[0-9a-f]{6}$/i.test(expandedHex)) {
          return;
        }

        const channels = [0, 2, 4].map((offset) => {
          const value = parseInt(expandedHex.slice(offset, offset + 2), 16) / 255;
          return value <= 0.04045
            ? value / 12.92
            : ((value + 0.055) / 1.055) ** 2.4;
        });
        const luminance = channels[0] * 0.2126
          + channels[1] * 0.7152
          + channels[2] * 0.0722;
        bar.style.setProperty(textProperty, luminance <= 0.179 ? '#ffffff' : '#000000');
      };

      /*
       * 移出商品页的 overflow 容器，确保移动端预览和 iOS
       * 都以真实视口作为 fixed 的定位与裁切参照。
       */
      if (bar.parentElement !== document.body) {
        document.body.appendChild(bar);
      }

      const updatePageOffset = () => {
        document.documentElement.style.setProperty(
          '--product-sticky-bar-height',
          `${bar.getBoundingClientRect().height}px`
        );
        document.body.classList.add('product-sticky-bar-active');
      };

      const initialBackground = activeSwatch?.dataset.ctaBg
        || bar.style.getPropertyValue('--product-sticky-bar-bg');
      setBackgroundColours(initialBackground, '--product-sticky-bar-bg', '--product-sticky-bar-text');

      if ('ResizeObserver' in window) {
        new ResizeObserver(updatePageOffset).observe(bar);
      } else {
        window.addEventListener('resize', updatePageOffset);
      }

      updatePageOffset();

      document.addEventListener('ito:variant-change', (event) => {
        const variant = event.detail;
        if (!variant || !variant.id) return;
        if (input) input.value = variant.id;
        if (submit) {
          const soldOut = !variant.available;
          submit.disabled = soldOut;
          const label = bar.querySelector('[data-product-sticky-button-label]');
          if (label && submit.dataset.addLabel) {
            label.textContent = soldOut
              ? (submit.dataset.soldOutLabel || 'Sold out')
              : submit.dataset.addLabel;
          }
        }
        if (subtitle && variant.subtitle) subtitle.textContent = variant.subtitle;
        if (price && variant.price) price.textContent = variant.price;
        setBackgroundColours(variant.background, '--product-sticky-bar-bg', '--product-sticky-bar-text');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-product-detail]').forEach((root) => {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';

      root.querySelectorAll('.product-detail__upsell').forEach((card) => {
        const swatches = card.querySelectorAll('[data-upsell-swatch]');
        const variantInput = card.querySelector('[data-upsell-variant-id]');
        const price = card.querySelector('[data-upsell-price]');
        const image = card.querySelector('.product-detail__upsell-image');

        swatches.forEach((swatch) => {
          swatch.addEventListener('click', () => {
            if (swatch.disabled) return;

            if (variantInput) variantInput.value = swatch.dataset.variantId;
            if (price) price.textContent = swatch.dataset.price;
            if (image && swatch.dataset.image) {
              image.removeAttribute('srcset');
              image.removeAttribute('sizes');
              image.src = swatch.dataset.image;
            }

            swatches.forEach((item) => {
              const active = item === swatch;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-pressed', String(active));
            });
          });
        });
      });

      const stickyBar = document.querySelector('[data-product-sticky-bar]');
      const updateVisibleHeight = () => {
        const sectionTop = root.getBoundingClientRect().top + window.scrollY;
        const stickyHeight = stickyBar?.getBoundingClientRect().height || 0;
        const visibleHeight = Math.max(0, window.innerHeight - sectionTop - stickyHeight);
        root.style.setProperty('--pd-visible-height', `${visibleHeight}px`);
      };

      updateVisibleHeight();
      window.addEventListener('resize', updateVisibleHeight);
      window.addEventListener('load', updateVisibleHeight);
      if (stickyBar && 'ResizeObserver' in window) {
        new ResizeObserver(updateVisibleHeight).observe(stickyBar);
      }

      const isAccessory = root.dataset.productMode === 'accessory';
      const colorOptionIndex = Number(root.dataset.colorOptionIndex);
      const accessoryVariantsNode = root.querySelector('[data-accessory-variants]');
      const accessoryVariants = accessoryVariantsNode
        ? JSON.parse(accessoryVariantsNode.textContent)
        : [];
      const input = root.querySelector('[data-product-id]');
      const price = root.querySelector('[data-product-price]');
      const colour = root.querySelector('[data-product-colour]');
      const size = root.querySelector('[data-product-size]');
      const submit = root.querySelector('[data-product-submit]');
      const swatches = root.querySelectorAll('[data-product-variant]');
      const setCtaColours = (background, fallbackText) => {
        if (!background) return root.style.getPropertyValue('--pd-cta-text').trim();

        root.style.setProperty('--pd-cta-bg', background);
        const hex = background.trim().replace(/^#/, '');
        const expandedHex = hex.length === 3
          ? hex.split('').map((digit) => digit + digit).join('')
          : hex;

        if (!/^[0-9a-f]{6}$/i.test(expandedHex)) {
          if (fallbackText) root.style.setProperty('--pd-cta-text', fallbackText);
          return root.style.getPropertyValue('--pd-cta-text').trim();
        }

        const channels = [0, 2, 4].map((offset) => {
          const value = parseInt(expandedHex.slice(offset, offset + 2), 16) / 255;
          return value <= 0.04045
            ? value / 12.92
            : ((value + 0.055) / 1.055) ** 2.4;
        });
        const luminance = channels[0] * 0.2126
          + channels[1] * 0.7152
          + channels[2] * 0.0722;
        const textColour = luminance <= 0.179 ? '#ffffff' : '#000000';
        root.style.setProperty('--pd-cta-text', textColour);
        return textColour;
      };

      setCtaColours(root.style.getPropertyValue('--pd-cta-bg'));
      const galleryItems = Array.from(
        root.querySelectorAll('[data-gallery-colour]')
      );
      const galleryGrid = root.querySelector(
        '.product-detail__gallery-grid'
      );
      const progress = root.querySelector(
        '.product-detail__progress'
      );
      let activeGalleryItems = [];
      let galleryScrollFrame = null;
      let galleryPointerId = null;
      let galleryDragStartX = 0;
      let galleryDragStartY = 0;
      let galleryDragStartScrollLeft = 0;
      let galleryIsDragging = false;
      const sizeGuideTrigger = root.querySelector(
        '[data-product-size-guide-trigger]'
      );
      const sizeGuideDialog = root.querySelector(
        '[data-product-size-guide-dialog]'
      );
      const sizeDropdown = root.querySelector(
        '[data-series-size-dropdown]'
      );
      const sizeOptions = Array.from(
        root.querySelectorAll('[data-product-size-option]')
      );
      const airlineTrigger = root.querySelector(
        '[data-airline-compatibility-trigger]'
      );
      const airlineDialog = root.querySelector(
        '[data-airline-compatibility-dialog]'
      );
      
      const defaultButton =
  root.querySelector('[data-product-variant].is-active') ||
  swatches[0];
      let sizeGuideSelectedSize = null;

      sizeOptions.forEach((option) => {
        option.addEventListener('change', () => {
          if (!option.checked || !option.dataset.url) return;

          window.location.assign(option.dataset.url);
        });
      });

      if (sizeGuideTrigger && sizeGuideDialog) {
        sizeGuideTrigger.addEventListener('click', (event) => {
          event.preventDefault();

          if (!sizeGuideDialog.open) {
            sizeGuideSelectedSize =
              sizeOptions.find((option) => option.checked)?.value ||
              null;
            sizeDropdown?.removeAttribute('open');
            sizeGuideDialog.showModal();
            document.body.classList.add(
              'product-size-guide-open'
            );
          }
        });

        sizeGuideDialog
          .querySelector('[data-product-size-guide-close]')
          ?.addEventListener('click', () => {
            sizeGuideDialog.close();
          });

        sizeGuideDialog.addEventListener('click', (event) => {
          if (event.target === sizeGuideDialog) {
            sizeGuideDialog.close();
          }
        });

        sizeGuideDialog.addEventListener('close', () => {
          document.body.classList.remove(
            'product-size-guide-open'
          );

          if (sizeGuideSelectedSize) {
            const selectedOption = sizeOptions.find(
              (option) => option.value === sizeGuideSelectedSize
            );

            if (selectedOption) {
              selectedOption.checked = true;
            }
          }

          sizeGuideTrigger.focus();
        });
      }

      if (airlineTrigger && airlineDialog) {
        airlineTrigger.addEventListener('click', (event) => {
          event.preventDefault();

          if (!airlineDialog.open) {
            airlineDialog.showModal();
            document.body.classList.add(
              'product-airline-compatibility-open'
            );
          }
        });

        airlineDialog
          .querySelector('[data-airline-compatibility-close]')
          ?.addEventListener('click', () => {
            airlineDialog.close();
          });

        airlineDialog.addEventListener('click', (event) => {
          if (event.target === airlineDialog) {
            airlineDialog.close();
          }
        });

        airlineDialog.addEventListener('close', () => {
          document.body.classList.remove(
            'product-airline-compatibility-open'
          );
        });
      }

      const normalizeColour = (value) => {
  return (value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();
};

      const updateGalleryProgress = () => {
        galleryScrollFrame = null;

        if (
          !galleryGrid ||
          !progress ||
          activeGalleryItems.length === 0
        ) {
          return;
        }

        const slideWidth = galleryGrid.clientWidth;
        if (!slideWidth) return;

        const activeIndex = Math.max(
          0,
          Math.min(
            activeGalleryItems.length - 1,
            Math.round(galleryGrid.scrollLeft / slideWidth)
          )
        );

        progress
          .querySelectorAll('span')
          .forEach((item, index) => {
            item.classList.toggle(
              'is-active',
              index === activeIndex
            );
          });
      };

      if (galleryGrid) {
        galleryGrid.addEventListener(
          'scroll',
          () => {
            if (galleryScrollFrame !== null) return;

            galleryScrollFrame =
              requestAnimationFrame(updateGalleryProgress);
          },
          { passive: true }
        );

        galleryGrid.addEventListener(
          'pointerdown',
          (event) => {
            if (
              event.pointerType === 'mouse' &&
              event.button !== 0
            ) {
              return;
            }

            galleryPointerId = event.pointerId;
            galleryDragStartX = event.clientX;
            galleryDragStartY = event.clientY;
            galleryDragStartScrollLeft =
              galleryGrid.scrollLeft;
            galleryIsDragging = false;
            galleryGrid.setPointerCapture(
              event.pointerId
            );
          }
        );

        galleryGrid.addEventListener(
          'pointermove',
          (event) => {
            if (event.pointerId !== galleryPointerId) {
              return;
            }

            const deltaX =
              event.clientX - galleryDragStartX;
            const deltaY =
              event.clientY - galleryDragStartY;

            if (
              !galleryIsDragging &&
              Math.abs(deltaX) > 8 &&
              Math.abs(deltaX) > Math.abs(deltaY)
            ) {
              galleryIsDragging = true;
              galleryGrid.classList.add('is-dragging');
            }

            if (!galleryIsDragging) return;

            event.preventDefault();
            galleryGrid.scrollLeft =
              galleryDragStartScrollLeft - deltaX;
          },
          { passive: false }
        );

        const finishGalleryDrag = (event) => {
          if (event.pointerId !== galleryPointerId) {
            return;
          }

          if (
            galleryGrid.hasPointerCapture(
              event.pointerId
            )
          ) {
            galleryGrid.releasePointerCapture(
              event.pointerId
            );
          }

          galleryPointerId = null;
          galleryGrid.classList.remove('is-dragging');

          if (!galleryIsDragging) return;
          galleryIsDragging = false;

          const slideWidth = galleryGrid.clientWidth;
          if (!slideWidth) return;

          const targetIndex = Math.max(
            0,
            Math.min(
              activeGalleryItems.length - 1,
              Math.round(
                galleryGrid.scrollLeft / slideWidth
              )
            )
          );

          galleryGrid.scrollTo({
            left: targetIndex * slideWidth,
            behavior: 'smooth'
          });
        };

        galleryGrid.addEventListener(
          'pointerup',
          finishGalleryDrag
        );
        galleryGrid.addEventListener(
          'pointercancel',
          finishGalleryDrag
        );
      }

      const updateGallery = (
  selectedColour,
  useDefaultGroup = false
) => {
  const selectedKey = normalizeColour(selectedColour);

  let visibleItems = galleryItems.filter((item) => {
    return (
      normalizeColour(item.dataset.galleryColour) ===
      selectedKey
    );
  });

  /*
   * 如果默认颜色名称没有匹配到替代文本，
   * 使用图库中第一组图片的替代文本作为默认组。
   */
  if (visibleItems.length === 0 && useDefaultGroup) {
    const firstTaggedItem = galleryItems.find((item) => {
      return normalizeColour(
        item.dataset.galleryColour
      );
    });

    const defaultGalleryKey = normalizeColour(
      firstTaggedItem
        ? firstTaggedItem.dataset.galleryColour
        : ''
    );

    if (defaultGalleryKey) {
      visibleItems = galleryItems.filter((item) => {
        return (
          normalizeColour(item.dataset.galleryColour) ===
          defaultGalleryKey
        );
      });
    }
  }

        /*
         * 没有匹配图片时保留当前图库，
         * 避免整组图片突然消失。
         */
        if (visibleItems.length === 0) return;

        activeGalleryItems = visibleItems;

        galleryItems.forEach((item) => {
          item.hidden = !visibleItems.includes(item);

          item.classList.remove(
            'product-detail__media--large',
            'product-detail__media--half',
            'product-detail__media--half-left',
            'product-detail__media--primary'
          );
        });

        visibleItems.forEach((item, index) => {
          const layoutPosition = index % 3;

          if (layoutPosition === 0) {
            item.classList.add(
              'product-detail__media--large'
            );
          } else {
            item.classList.add(
              'product-detail__media--half'
            );
          }

          if (layoutPosition === 1) {
            item.classList.add(
              'product-detail__media--half-left'
            );
          }

          if (index === 0) {
            item.classList.add(
              'product-detail__media--primary'
            );
          }
        });

        if (progress) {
          progress.innerHTML = visibleItems
            .map((item, index) => {
              return index === 0
                ? '<span class="is-active"></span>'
                : '<span></span>';
            })
            .join('');

          progress.style.gridTemplateColumns =
            `repeat(${visibleItems.length}, 1fr)`;
        }

        if (galleryGrid) {
          galleryGrid.scrollLeft = 0;
        }
      };

      const applyVariant = (button) => {
        const unifiedColor = button.dataset.ctaBg;

        if (input) {
          input.value = button.dataset.id;
        }

        if (price) {
          price.textContent = button.dataset.price;
        }

        if (size) {
          size.textContent = button.dataset.size;
        }

        if (colour) {
          colour.textContent = button.dataset.colour;
        }

        if (submit) {
          const soldOut = button.dataset.available !== 'true';
          submit.disabled = soldOut;
          if (submit.dataset.addLabel) {
            submit.textContent = soldOut
              ? (submit.dataset.soldOutLabel || 'Sold out')
              : submit.dataset.addLabel;
          }
        }

        /*
         * 根据颜色名称和图片替代文本，
         * 切换当前显示的整组图库。
         */
        updateGallery(
  button.dataset.colour,
  button === defaultButton
);

        const ctaText = setCtaColours(unifiedColor, button.dataset.ctaText);

        swatches.forEach((item) => {
          const isActive = item === button;

          item.classList.toggle(
            'is-active',
            isActive
          );

          item.setAttribute(
            'aria-pressed',
            isActive ? 'true' : 'false'
          );
        });

        document.dispatchEvent(
          new CustomEvent('ito:variant-change', {
            detail: {
              id: button.dataset.id,
              available:
                button.dataset.available === 'true',
              subtitle: button.dataset.size,
              price: button.dataset.price,
              background: unifiedColor,
              ctaBackground: unifiedColor,
              ctaText
            }
          })
        );
      };

      if (isAccessory && accessoryVariants.length > 0) {
        const accessoryControls = Array.from(
          root.querySelectorAll('[data-accessory-option-value]')
        );
        let activeAccessoryVariant = accessoryVariants.find(
          (variant) => String(variant.id) === input?.value
        ) || accessoryVariants[0];
        const selections = [...activeAccessoryVariant.options];

        const findExactAccessoryVariant = () => accessoryVariants.find(
          (variant) => variant.options.every(
            (value, index) => value === selections[index]
          )
        );

        const findAccessoryFallback = (changedIndex) => accessoryVariants.find(
          (variant) => variant.sellable && variant.options.every(
            (value, index) => index > changedIndex || value === selections[index]
          )
        );

        const accessoryOptionAvailable = (optionIndex, optionValue) => accessoryVariants.some(
          (variant) => variant.sellable &&
            variant.options[optionIndex] === optionValue &&
            variant.options.every(
              (value, index) => index >= optionIndex || value === selections[index]
            )
        );

        const updateAccessoryControls = () => {
          accessoryControls.forEach((control) => {
            const optionIndex = Number(control.dataset.optionIndex);
            const isActive = selections[optionIndex] === control.dataset.optionValue;

            if (control.matches('button')) {
              control.classList.toggle('is-active', isActive);
              control.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            } else {
              control.checked = isActive;
              control.closest('.product-detail__size-option')
                ?.classList.toggle('is-current', isActive);
            }

            control.disabled = !isActive && !accessoryOptionAvailable(
              optionIndex,
              control.dataset.optionValue
            );
          });

          root.querySelectorAll('[data-accessory-option-group]').forEach((group) => {
            const optionIndex = Number(group.dataset.optionIndex);
            const summary = group.querySelector('[data-accessory-option-summary]');
            if (summary) summary.textContent = selections[optionIndex] || '';
          });
        };

        const applyAccessoryVariant = (
          variant,
          useDefaultGallery = false,
          updateUrl = true
        ) => {
          if (!variant) return;
          activeAccessoryVariant = variant;

          if (input) input.value = variant.id;
          if (price) price.textContent = variant.price;
          if (submit) {
            const soldOut = !variant.sellable;
            submit.disabled = soldOut;
            if (submit.dataset.addLabel) {
              submit.textContent = soldOut
                ? (submit.dataset.soldOutLabel || 'Sold out')
                : submit.dataset.addLabel;
            }
          }

          const selectedColour = colorOptionIndex >= 0
            ? variant.options[colorOptionIndex]
            : '';
          const activeColourControl = colorOptionIndex >= 0
            ? accessoryControls.find((control) =>
                Number(control.dataset.optionIndex) === colorOptionIndex &&
                control.dataset.optionValue === selectedColour
              )
            : null;
          const unifiedColour = colorOptionIndex < 0
            ? '#ffffff'
            : activeColourControl?.dataset.ctaBg || variant.ctaBackground;

          if (colour && selectedColour) colour.textContent = selectedColour;
          if (selectedColour) updateGallery(selectedColour, useDefaultGallery);

          const ctaText = setCtaColours(unifiedColour, variant.ctaText);

          if (updateUrl && window.history?.replaceState) {
            const variantUrl = new URL(window.location.href);
            variantUrl.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', variantUrl.toString());
          }

          document.dispatchEvent(new CustomEvent('ito:variant-change', {
            detail: {
              id: variant.id,
              available: variant.sellable,
              subtitle: variant.subtitle,
              price: variant.price,
              background: unifiedColour,
              ctaBackground: unifiedColour,
              ctaText
            }
          }));
        };

        const chooseAccessoryOption = (control) => {
          const changedIndex = Number(control.dataset.optionIndex);
          selections[changedIndex] = control.dataset.optionValue;

          let nextVariant = findExactAccessoryVariant();
          if (!nextVariant || !nextVariant.available) {
            nextVariant = findAccessoryFallback(changedIndex);
          }

          if (nextVariant) {
            nextVariant.options.forEach((value, index) => {
              selections[index] = value;
            });
          }

          updateAccessoryControls();
          applyAccessoryVariant(nextVariant || findExactAccessoryVariant());
          control.closest('[data-accessory-option-dropdown]')?.removeAttribute('open');
        };

        accessoryControls.forEach((control) => {
          control.addEventListener(
            control.matches('button') ? 'click' : 'change',
            () => chooseAccessoryOption(control)
          );
        });

        updateAccessoryControls();
        applyAccessoryVariant(activeAccessoryVariant, true, false);
      } else {
        swatches.forEach((button) => {
          button.addEventListener('click', () => {
            applyVariant(button);
          });
        });

        if (defaultButton) {
          applyVariant(defaultButton);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded',function(){
    var prodquery = document.querySelectorAll('.bls__shop-lookbook-content .bls__section-subheading.customerizeTitle')
    prodquery.forEach(prodEl=>{
      var title = prodEl.innerText
      if(title){
        var newT = showCustomerizeName(title)
        prodEl.innerText = ''
        prodEl.insertAdjacentHTML('afterbegin',newT)
        // if(prodEl.getElementsByTagName('div').length>0){
        //   var condNode = prodEl.getElementsByTagName('div')[0]
        //   condNode.style.width = condNode.clientWidth*0.8 + 'px'
        // }
        if(prodEl.getElementsByTagName('text').length>0){
          var condNode = prodEl.getElementsByTagName('text')[1]
          condNode.style.color = 'black'
        }
      }
    })
  })
  
  document.addEventListener('DOMContentLoaded',function(){
    var prodquery = document.querySelectorAll('.bls__shop-lookbook-content .bls__section-des.customerizeTitle')
    prodquery.forEach(prodEl=>{
      var title = prodEl.innerText
      if(title){
        var newT = replaceCustomerizeName(title)
        prodEl.innerText = ''
        prodEl.insertAdjacentHTML('afterbegin',newT)
        // if(prodEl.getElementsByTagName('div').length>0){
        //   var condNode = prodEl.getElementsByTagName('div')[0]
        //   condNode.style.width = condNode.clientWidth*0.8 + 'px'
        // }
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded',function(){
    var prodquery = document.querySelectorAll('.slide__block-title.customerizeTitle')
    prodquery.forEach(prodEl=>{
      var title = prodEl.innerText
      console.log('slide',title)
      if(title){
        var newT = showCustomerizeName(title)
        prodEl.innerText = ''
        prodEl.insertAdjacentHTML('afterbegin',newT)
        // var condNode = prodEl.getElementsByTagName('div')[0]
        // condNode.style.width = condNode.clientWidth*0.8 + 'px'
      }
    })
  })
  

  } catch(e) { console.error(e); }
})();
})();
